import 'babel-polyfill';
import './setup/polyfills';
import './bootstrap';
import '../../../resources/styles/theme.css';
import Vue from 'vue';
import { sync } from 'vuex-router-sync';

import './setup/validators';
import './setup/plugins';
import './setup/mixins';
import Toasted from 'vue-toasted';
import store from './vuex/store';
import router from './router';

import { grabWURFL } from '@H/device_helpers';
import { retry } from '@H/utils';

import jwt from 'jsonwebtoken';

import VueCardFormat from 'vue-credit-card-validation';
Vue.use(VueCardFormat);

// Globally assigns `svg-rndr` component.
// Usage: <svg-rndr svg="check-green.svg" />
import '@C/SVGRendererComponent';
Vue.use(Toasted)
sync(store, router);

window.Vue = Vue;
Vue.config.devtools = true;
Vue.config.performance = true;

window.jwt = jwt;

Vue.component('widget-container', require('@C/Widgets/Container.vue'));
Vue.component('wrapper', require('@C/Wrapper.vue'));
Vue.component('loader', require('@C/Loader.vue'));

// Date range picket
window.moment = require('moment');
window.moment.locale('en');

window.Chargebee.init({
    site:  process.env.MIX_CB_SITE,
    publishableKey: process.env.MIX_CB_API_KEY_FRONT
});

// Grabs the WURFL script and attempts to set the body class
retry(grabWURFL, 5).then(() => {
    const app = new Vue({
        el: '#app',
        router,
        store
    });

    // Allows us to translate attributes using :attribute="'text to translate' | translate"
    Vue.filter('translate', value => {
        return !value ? '' : app.$gettext(value.toString())
    });

    window.$gettext = app.$gettext;
    window.$ngettext = app.$ngettext;
    window.$gettextInterpolate = app.$gettextInterpolate;


    // Handle failed ajax calls globally to deal with session expiry & csrf tokens
    window.axios.interceptors.response.use(null, function (error) {
        if (error.config && error.response && error.response.status === 419) {
            axios
                .post('/csrf')
                .then(
                    res => {
                        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = error.config.headers['X-CSRF-TOKEN'] = res.data;

                        // Retry the request now that we've refreshed the csrf token
                        return axios.request(error.config);
                    }
                );
        } else if (error.response && error.response.status === 401) {
            // Authenticated error (401) implies the session has expired since our last page-load or ajax request
            store.dispatch('Flash/setFlash', {
                message: $gettext('Your session has expired, please login again.')
            }, { root: true });

            // So force a full logout which will handle clearing the state and redirecting the user
            return store.dispatch('Auth/logout');
        }

        return Promise.reject(error);
    });
}).catch(() => {
    window.location.reload();
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js